import React from "react";
import { Icon } from "./Icon.jsx";

/* Square icon-only button. variant: ghost | outline | solid. */
const SIZES = { sm: 32, md: 38, lg: 44 };
const ICON = { sm: 18, md: 20, lg: 22 };

export function IconButton({
  icon,
  variant = "ghost",
  size = "md",
  active = false,
  disabled = false,
  label,
  onClick,
  style,
  ...rest
}) {
  const [hover, setHover] = React.useState(false);
  const dim = SIZES[size] || SIZES.md;

  let bg = "transparent";
  let color = "var(--text-body)";
  let shadow = "none";
  if (variant === "outline") shadow = "inset 0 0 0 1px var(--border)";
  if (variant === "solid") { bg = "var(--mint)"; }
  if (active) { bg = "var(--mint-light)"; color = "var(--green-success)"; }
  if (hover && !disabled && !active) bg = "var(--grey-bg)";
  if (disabled) color = "var(--text-disabled)";

  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      disabled={disabled}
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: dim,
        height: dim,
        border: "none",
        borderRadius: "var(--radius-xs)",
        background: bg,
        color,
        boxShadow: shadow,
        cursor: disabled ? "not-allowed" : "pointer",
        transition: "background var(--dur) var(--ease), color var(--dur) var(--ease)",
        ...style,
      }}
      {...rest}
    >
      <Icon name={icon} size={ICON[size] || 20} />
    </button>
  );
}

export default IconButton;
